import { Environment } from '../config/environment';
import { Backend } from './Backend';
import { IRibbon2Container } from './models/AndromeTV.types';
import { ArticleListParam, CustomContentParam, FixedContentParam, GenericContentParam } from './CmsApi.types';

export class CmsApi {
  /**
   * Retrieve a customContent ribbon/grid from the backend
   */
  static customContent(backend: Backend, contentId: string, param: CustomContentParam): Promise<IRibbon2Container[]> {
    const queryParam = {
      platform: Environment.system,
      ...param,
    };
    const url = backend.makeUrl(`cms/v2/content/custom/${encodeURIComponent(contentId)}`, queryParam);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container[]>;
  }

  /**
   * Retrieve a fixedContent ribbon/grid from the backend
   */
  static fixedContent(backend: Backend, contentId: string, param: FixedContentParam): Promise<IRibbon2Container[]> {
    const queryParam = {
      platform: Environment.system,
      ...param,
    };
    const url = backend.makeUrl(`cms/v2/content/fixed/${encodeURIComponent(contentId)}`, queryParam);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container[]>;
  }

  /**
   * Retrieve generic content ribbon from the backend
   */
  static genericContent(backend: Backend, contentId: string, param: GenericContentParam): Promise<IRibbon2Container[]> {
    const queryParam = {
      platform: Environment.system,
      ...param,
    };
    const url = backend.makeUrl(`cms/v1/content/generic/${encodeURIComponent(contentId)}`, queryParam);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container[]>;
  }

  /**
   * Retrieve ribbon content from a backend provided url
   */
  static ribbonContent(backend: Backend, url: string): Promise<IRibbon2Container> {
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container>;
  }

  /**
   * Retrieve a ribbon filled with articles
   */
  static articleList(backend: Backend, param: ArticleListParam): Promise<IRibbon2Container> {
    const url = backend.makeUrl('cms/v2/cms/article', param);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container>;
  }
}
